import { memo } from "react";
import { useTranslation } from "react-i18next";
import CustomButton from "sipli-fleet-core/components/CustomSharedButton/CustomSharedButton";
import type { CustomButtonProps } from "sipli-fleet-core/components/CustomSharedButton/CustomSharedButton";
import { cn } from "sipli-fleet-core/utils/cn";

export interface CustomActionButtonsProps {
  className?: string;
  onCancel?: () => void;
  onOk?: () => void;
  loading?: boolean;
  cancelProps?: Partial<CustomButtonProps>;
  okProps?: Partial<CustomButtonProps>;
  disabled?: boolean;
  cancelBtnLabel?: string;
  okBtnLabel?: string;
}

function CustomActionButtons({
  className,
  onCancel = () => {},
  onOk = () => {},
  loading = false,
  cancelProps = {},
  okProps = {},
  disabled,
  cancelBtnLabel = "cancel",
  okBtnLabel = "save",
}: CustomActionButtonsProps) {
  const { t } = useTranslation();

  return (
    <div className={cn("flex gap-2 justify-end h-[40px]", className)}>
      <CustomButton
        label={t(cancelBtnLabel)}
        type="secondary"
        className="!h-full !px-6 !text-[14px]"
        onClick={onCancel}
        {...cancelProps}
      />
      <CustomButton
        label={t(okBtnLabel)}
        className="!h-full !px-6 !text-[14px]"
        onClick={onOk}
        loading={loading}
        disabled={disabled}
        {...okProps}
      />
    </div>
  );
}

export default memo(CustomActionButtons)
